/* eslint-disable no-unused-vars */
/* eslint-disable prefer-template */
import React, { useEffect, useState } from 'react'
import Head from 'next/head'
import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import axios from 'axios'

import { fetchPage } from '../state/ducks/page'
import { loadSettings } from '../state/ducks/settings'
import Header from '../components/Header'
import Footer from '../components/Footer'
import State from '../components/State'
import marriageDate from '../utils/date'
import getHost from '../utils/env'

const HOC = (Component, page) => ({
  currentPage,
  status,
  settings,
  cart,
  ...props
}) => {
  useEffect(() => {
    (async () => {
      const host = getHost(window.location.host)
      const { data } = await axios({
        method: 'GET',
        url: `${host}resources`,
        headers: {
          'origin-local': 'http://joaoemaria.caseme.local',
        },
      })

      props.loadSettings({ ...data, host })
      props.fetchPage(page)
    })()
  }, [])

  const makeMenu = (config) => {
    const fixedLinks = Object.keys(config.structure.menu.fixed)
    const extraLinks = Object.keys(config.structure.menu.extra || [])

    const fixedMenu = fixedLinks.map((item) => {
      const i = config.structure.menu.fixed[item]

      return {
        slug: i.slug,
        name: i.text,
      }
    })

    const extraMenu = extraLinks.map((item) => {
      const i = config.structure.menu.extra[item]

      return {
        slug: `others/?page=${i.slug}`,
        name: i.menu,
      }
    })

    return [...fixedMenu, ...extraMenu]
  }

  const makeHeader = (config) => {
    const { layout } = config
    const fonts = Object.keys(layout.fonts)
    const { couple, date } = config.marriage    
    let newTitle
    let eventDate

    if (couple.length === 0 && date.length === 0) {
      newTitle = 'CaseMe'
      eventDate = ''
    } else {
      newTitle = `${couple} | ${marriageDate(date)} - CaseMe`
      eventDate = `${marriageDate(date)}`
    }

    const makeStyle = (styles) => {
      let classes = ''

      styles.forEach((font) => {
        if (font === 'primary') {
          classes += `.${font}{ font-family: ${layout.fonts[font].css} !important; font-size: ${layout.text_size[font]}vw !important; }`
        } else {
          classes += `.${font}{ font-family: ${layout.fonts[font].css} !important; font-size: ${layout.text_size[font]}vmin !important; }`
        }
        classes += `.${font}-bg{background-color: ${layout.colors[font]} !important;}`
        classes += `.${font}-color{color: ${layout.colors[font]} !important;}`
        classes += `.${font}-button {background-color: #fff !important; color: ${layout.colors[font]} !important; border: 1px solid ${layout.colors[font]} !important;} .${font}-button:hover, .${font}-button.active {background-color: ${layout.colors[font]} !important; color: #fff !important;}`
				classes += `.${font}-bg-button {color: #fff !important; background-color: ${layout.colors[font]} !important; border: 1px solid ${layout.colors[font]} !important;} .${font}-button:hover, .${font}-button.active {color: ${layout.colors[font]} !important; background-color: #fff !important;}`
      })
      // console.log('Classes: ', classes)
      return classes
    }

    return (
      <>
        <title>{newTitle}</title>      

        {fonts.map((f) => (
          <link
            key={f}
            href={`${layout.fonts[f].google_link}&display=swap`}
            rel="stylesheet"
          />
        ))}

        <style dangerouslySetInnerHTML={{ __html: makeStyle(fonts) }} />
      </>
    )
  }  	
  return (
    <>
      <Head>{makeHeader(settings)}</Head>
      <State status={status} onRetry={() => props.fetchPage(page)}>
        <>
          <Header
            activePage={page}
            links={makeMenu(settings)}
            currentPage={currentPage}
            settings={settings}
            cartItems={cart.items.length}
          />
          <Component {...props} settings={settings} data={currentPage} />
          <Footer settings={settings} />
        </>
      </State>
    </>
  )
}

const mapStateToProps = (state) => ({
  currentPage: state.currentPage.page,
  settings: state.settings,
  status: state.currentPage.status,
  cart: state.cart,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPage,
      loadSettings,
    },
    dispatch
  )

export default compose(connect(mapStateToProps, mapDispatchToProps), HOC)
